// Vuex module for tracking user context metadata for feedback/contact widget

const state = {
	widgetMetadata: {
		viewingBrandId: null,
		connectingToBrandId: null,
		creatingOpportunityId: null,
		aiBriefWriterId: null,
		aiIterationId: null,
		openWindows: [],
	},
	widgetOpenRequest: null,
};

const getters = {
	metadata: (state) => state.widgetMetadata,
	widgetOpenRequest: (state) => state.widgetOpenRequest,

	hasMetadata: (state) => {
		const meta = state.widgetMetadata;
		return !!(
			meta.viewingBrandId ||
			meta.connectingToBrandId ||
			meta.creatingOpportunityId ||
			meta.aiBriefWriterId ||
			meta.aiIterationId ||
			(meta.openWindows && meta.openWindows.length > 0)
		);
	},
};

const normaliseWidgetOpenRequest = (payload = {}) => {
	const nextType = payload?.type === "contact" || payload?.type === "feedback" ? payload.type : null;
	const nextMessage = typeof payload?.message === "string" ? payload.message : "";

	return {
		type: nextType,
		message: nextMessage,
	};
};

const mutations = {
	setMetadata(state, { key, value }) {
		if (key in state.widgetMetadata) {
			state.widgetMetadata[key] = value;
		}
	},

	clearMetadata(state, key) {
		if (key) {
			// Clear specific metadata field
			if (key in state.widgetMetadata) {
				if (key === "openWindows") {
					state.widgetMetadata[key] = [];
				} else {
					state.widgetMetadata[key] = null;
				}
			}
		} else {
			// Clear all metadata
			state.widgetMetadata = {
				viewingBrandId: null,
				connectingToBrandId: null,
				creatingOpportunityId: null,
				aiBriefWriterId: null,
				aiIterationId: null,
				openWindows: [],
			};
		}
	},

	setOpenWindow(state, windowName) {
		if (!state.widgetMetadata.openWindows.includes(windowName)) {
			state.widgetMetadata.openWindows.push(windowName);
		}
	},

	removeOpenWindow(state, windowName) {
		const index = state.widgetMetadata.openWindows.indexOf(windowName);
		if (index > -1) {
			state.widgetMetadata.openWindows.splice(index, 1);
		}
	},

	requestWidgetOpen(state, payload = {}) {
		state.widgetOpenRequest = normaliseWidgetOpenRequest(payload);
	},

	clearWidgetOpenRequest(state) {
		state.widgetOpenRequest = null;
	},
};

const actions = {
	openWidget({ commit }, payload = {}) {
		commit("requestWidgetOpen", payload);
	},

	clearOpenWidgetRequest({ commit }) {
		commit("clearWidgetOpenRequest");
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
